import { useEffect } from 'react';
import { store, storeActions, useSirenEntity, useStoreValues } from '~/runtime';
import { Measurements } from '~/domain/measurements/measurements.js';
import { preferences } from '~/domain/measurements/preferences.js';
import i18n from '~/translations/i18n.js';

/**
 * Listens for changes to the store.currentUserHref
 * Then initializes/updates preferences & user features
 */
export function useCurrentUserInitializer() {
  const { currentUserHref } = useStoreValues(['currentUserHref']);
  const { entity: currentUserEntity } = useSirenEntity({ href: currentUserHref });
  useEffect(() => {
    if (!currentUserEntity) {
      return;
    }

    const preferenceEntities = currentUserEntity.getSubEntitiesByClass('preferences');
    const preferencesToStore = {};
    preferenceEntities.forEach((preference) => {
      const group = preference.class.filter((cl) => cl !== 'preferences')[0];
      preferencesToStore[group] = preference.properties;
    });

    store.dispatch(
      storeActions.setPreferences({
        ...preferencesToStore,
        binLevelMetric: 'volume',
      }),
    );
    store.dispatch(storeActions.setUserFeatures(currentUserEntity.properties.features));

    // Update i18n language based on user preference
    let preferredLanguage = currentUserEntity?.properties?.preferredLanguage;

    if (preferredLanguage && i18n.language !== preferredLanguage) {
      i18n.changeLanguage(preferredLanguage);
    }

    preferences.flushCache();
    Measurements.flushCache();
  }, [currentUserEntity]);
}
